import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { configApi } from '../api';
import { ACTION_TYPES } from './store/config.action';

export const getProfile = () => async dispatch => {
  try {
    const response = await configApi.getProfile();
    dispatch({
      type: ACTION_TYPES.GET_PROFILE,
      payload: response
    });
  } catch (err) {
    console.log(err);
  }
};

export const getConfig = productCode => async dispatch => {
  const { authorizedCountries, listTitle, steps, withoutOffer } = (await configApi.getConfig()).data;
  await dispatch({
    type: ACTION_TYPES.GET_CONFIG,
    payload: {
      countries: authorizedCountries[productCode],
      title: listTitle[productCode],
      steps: steps[productCode],
      isWithoutOffer: withoutOffer[productCode]
    }
  });
};

export const getAuthInfo = () => async dispatch => {
  const result = await configApi.getAuthInfo();

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  await dispatch({
    type: ACTION_TYPES.GET_AUTH_INFO,
    payload: result.getValue()
  });
};

export const getProductCodeAndConfig = () => async (dispatch, getState) => {
  const result = await configApi.getInfos();

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const infos = result.getValue();

  await dispatch({
    type: ACTION_TYPES.GET_INFOS,
    payload: infos
  });

  // get Config for this product code
  await dispatch(getConfig(infos.productCode));

  // get Config Auth Info
  await dispatch(getAuthInfo());
};
